import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

import {
  DashboardCard,
  DashboardHighlightCard,
  DashboardPercentageCard,
} from '../../components/DashboardCards'

export const LeftColumn = styled(Box)`
  flex: 1;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const RightColumn = styled(Box)`
  width: 35%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`

export const SecondaryCard = styled(DashboardCard)`
  flex: 1 1 200px;
`

export const HighlightCustomCard = styled(DashboardHighlightCard)`
  flex: 1.8 1 280px;
`

export const PercentageCustomCard = styled(DashboardPercentageCard)`
  flex: 1.8 1 300px;
`
